export default (theme) => ({
    fieldHeader: { 
        margin: "10px 0 -10px"
    },
    dateHeader: { 
        margin: "10px 0 -6px"
    },
});